export const getYear = (): number => new Date().getFullYear()
